import { Category } from './Category.js'
import { Difficulty } from './Difficulty.js'
import { TokenType } from './Token.js'

export type BaseChallenge = {
  name: string
  description: string
  img: string
  author: string
  flag?: string
  flagPattern: string
  category: Category
  difficulty: Difficulty
  token?: ChallengeToken
}

export type ChallengeToken = {
  type: TokenType
  adminApiKey: string
}

export type Challenge = BaseChallenge & {
  isBroken: boolean
  _id: string
}

export const FlagPattern = {
  standard: 'STHACK{XXXXXXXXXXX}',
  disabled: '',
  standardInputPattern: 'STHACK\\{.+\\}',
}

export const DummyChallenge: Challenge = {
  _id: '',
  author: '',
  category: '',
  description: '',
  difficulty: 'easy',
  flagPattern: '',
  img: '',
  isBroken: false,
  name: '',
}
